module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "10px",
      "border": "2px solid #dce4ec"
    }
  }, [_c('table', {
    staticClass: "table border-top"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.controller.Rounds), function(round, index) {
    return [_c('tr', {}, [_c('td', {
      staticClass: "text-center"
    }, [(round.hasError) ? _c('div', [_c('i', {
      staticClass: "fa fa-exclamation-triangle text-danger"
    })]) : _c('div', [(round.Status == 'Current' && round.Dosage.value > 0) ? _c('i', {
      staticClass: "fa fa-check text-success"
    }) : _vm._e(), _vm._v(" "), (round.Status == 'New' && round.Dosage.value > 0) ? _c('i', {
      staticClass: "fa fa-plus text-success"
    }) : _vm._e(), _vm._v(" "), (round.Status == 'New' && round.Dosage.value == 0) ? _c('i', {
      staticClass: "fa fa-plus text-warning"
    }) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': round.Name.hasError, 'has-warning': round.Name.hasWarning, 'has-success': round.Name.hasSuccess
      },
      staticStyle: {
        "height": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.Name.value),
        expression: "round.Name.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Round Name"
      },
      domProps: {
        "value": (round.Name.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(round.Name, "value", $event.target.value)
        }
      }
    })])]), _c('td', [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': round.Time.hasError, 'has-warning': round.Time.hasWarning, 'has-success': round.Time.hasSuccess
      },
      staticStyle: {
        "height": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.Time.value),
        expression: "round.Time.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "HH:MM"
      },
      domProps: {
        "value": (round.Time.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(round.Time, "value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.HexColour.value),
        expression: "round.HexColour.value"
      }],
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (round.HexColour.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(round.HexColour, "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group",
      class: {
        'has-error': round.Dosage.hasError, 'has-warning': round.Dosage.hasWarning, 'has-success': round.Dosage.hasSuccess
      },
      staticStyle: {
        "height": "100%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.Dosage.value),
        expression: "round.Dosage.value"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "40px"
      },
      attrs: {
        "type": "text",
        "placeholder": "Dosage"
      },
      domProps: {
        "value": (round.Dosage.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(round.Dosage, "value", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-sm btn-link text-warning",
      staticStyle: {
        "padding": "1px"
      },
      attrs: {
        "disabled": !(round.Dosage.value > 0 || round.Status == 'New')
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.controller.Remove(round)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-15x fa-trash"
    }), _vm._v("  Delete")])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "10"
      }
    }, [(round.hasError) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("\n                        " + _vm._s(round.Name.message) + " " + _vm._s(round.Time.message) + " " + _vm._s(round.HexColour.message) + " " + _vm._s(round.Dosage.message) + "\n                    ")]) : _vm._e()])])]
  }), _vm._v(" "), _c('tr', {
    staticClass: "border-top"
  }, [_c('td', {
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('a', {
    staticClass: "btn btn-sm btn-link btn-primary",
    staticStyle: {
      "padding": "1px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.controller.Add($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-15x fa-plus"
  }), _vm._v("  Add")])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Round")]), _vm._v(" "), _c('th', [_vm._v("Time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "70px"
    }
  }, [_vm._v("Colour")]), _vm._v(" "), _c('th', [_vm._v("Dosage")]), _vm._v(" "), _c('th')])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d1b63c8c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d1b63c8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/RoundSelector/RoundSelector.scp.html
// module id = 511
// module chunks = 0